export default "__VITE_ASSET__CzU6I_tx__"